"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncZipAll = asyncZipAll;
exports.default = void 0;

var _asyncIterable = require("../../internal/async-iterable");

var _map = require("../$map/map");

async function* asyncZipAll(sources, {
  filler
} = {}) {
  const iters = sources.map(arg => arg[Symbol.asyncIterator]());
  const itersDone = iters.map(iter => ({
    done: false,
    iter
  }));

  try {
    while (true) {
      const results = (0, _map.map)(iters, iter => iter.next());
      const syncResults = await Promise.all(results);
      const zipped = new Array(iters.length);
      let i = 0;
      let allDone = true;

      for (const {
        value,
        done
      } of syncResults) {
        allDone = allDone && done;
        itersDone[i].done = done;
        zipped[i] = done ? filler : value;
        i++;
      }

      if (allDone) break;
      yield zipped;
    }
  } finally {
    for (const {
      iter,
      done
    } of itersDone) {
      if (!done && typeof iter.return === 'function') await iter.return();
    }
  }
}

var _default = (0, _asyncIterable.asyncIterableCurry)(asyncZipAll, {
  variadic: true,
  minArgs: 0,
  maxArgs: 1
});

exports.default = _default;